module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<i class="wpmenucart-icon-shopping-cart-0"></i>\n<span class="cartcontents">\n    '+
((__t=( items ))==null?'':__t)+
'\n</span>\n<span class="amount">\n    '+
((__t=( totalAmount ))==null?'':__t)+
'\n</span>';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/menu/common/menu-item-prices/shopping-cart-menu/shopping-cart-menu.html
 ** module id = 122
 ** module chunks = 1 2 3 4 5 6 7 10 11 13 16 17 22 25 26 87 98 172
 **/